import { defaultFieldInfo } from "../../../../Tools/Tools";

export const getDefaultFieldsGenNums = () => {
  return [
    {
      Name: "OrgTypeCls",
      Title: "CODE",
      Width: "7",
    },
    {
      Name: "OrgName",
      Title: "Учреждение",
      Width: "10",
    },
    {
      Name: "Value",
      Title: "След. номер",
      Width: "20",
    },
  ];
};

export const getColumnsGenNums = () => {
  return {
    title: [
      {
        fieldName: "OrgTypeCls",
        title: "CODE",
        width: 50,
        hide: true,
        hideInGrid: true,
        hideInCard: true,
        fieldInfo: {
          ...defaultFieldInfo,
          EditStyle: "64",
        },
      },
      {
        fieldName: "OrgName",
        title: "Учреждение",
        width: 200,
        fieldInfo: {
          ...defaultFieldInfo,
          EditStyle: "64",
        },
      },
      {
        fieldName: "Value",
        title: "След. номер",
        width: 100,
        fieldInfo: {
          ...defaultFieldInfo,
          EditStyle: "8",
        },
      },
    ],
  };
};
